export default "__VITE_ASSET__CPXjtf$z__"